<template>
  <div id="centerRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <div class="d-flex">
          <span class="fs-xl text_title mx-2 commonTitle">实时监控</span>
        </div>
      </div>
      <div class="body-box">
        <ul class="header_item">
          <li style="width: 5%">No</li>
          <li style="width: 36%">科室</li>
          <li style="width: 15%">库存</li>
          <li style="width: 22%">今日洗涤量</li>
          <li style="width: 22%">今日配送量</li>
        </ul>
        <vue-seamless-scroll
          :data="personList"
          :class-option="defineScroll"
          class="seamless-warp"
          ref="vueSeamlessScroll"
          @mousewheel.native="handleScroll"
        >
          <div class="item">
            <li v-for="(item, index) in personList" :key="index">
              <span style="width: 5%">{{ index + 1 }}</span>
              <span style="width: 36%" class="title" v-text="item.divisionName"></span>
              <span style="width: 15%" class="date" v-text="item.numStock"></span>
              <span style="width: 22%" class="date" v-text="item.numReceive"></span>
              <span style="width: 22%" class="date" v-text="item.numDelivery"></span>
            </li>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/index";
import { formatTime } from "@/utils/index";

export default {
  data() {
    return {
      params: {
        pageNum: 1,
        pageSize: 5000,
        customerId: "",
        startTime: formatTime(new Date(), "yyyy-MM-dd"),
        endTime: formatTime(new Date(), "yyyy-MM-dd"),
      },
      personList: [],
      timer: null,
    };
  },
  watch: {
    personList: {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.vueSeamlessScroll) {
            this.$refs.vueSeamlessScroll.reset();
          }
        });
      },
      immediate: true,
    },
  },
  computed: {
    defineScroll() {
      return {
        step: 0.06,
        limitMoveNum: 8,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 0,
      };
    },
  },
  mounted() {
    this.params.customerId = this.$route.query.customerId;
    this.$nextTick(() => {
      if (this.$refs.vueSeamlessScroll) {
        this.$refs.vueSeamlessScroll.reset();
      }
    });

    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, 30 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    async getData() {
      this.params.statusApprove = 0;
      const res = await api.getBigSkuDivision(this.params);
      if (res.ResultCode === 0) {
        this.personList = res.Result || [];
      }
    },
    handleScroll(e) {
      this.$refs.vueSeamlessScroll.yPos = this.$refs.vueSeamlessScroll.yPos - e.deltaY;
      if (this.$refs.vueSeamlessScroll.yPos > 0) {
        this.$refs.vueSeamlessScroll.yPos = 0;
        return;
      }
      if (
        Math.abs(this.$refs.vueSeamlessScroll.yPos) >
        this.$refs.vueSeamlessScroll.realBoxHeight / 2
      ) {
        this.$refs.vueSeamlessScroll.yPos = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#centerRight1 {
  padding: 16px;
  padding-top: 20px;
  height: 100%;
  width: 100%;
  border-radius: 5px;

  .bg-color-black {
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
  }

  .body-box {
    border-radius: 10px;
    overflow: hidden;
    padding: 5px 10px;

    .header_item {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      text-align: center;

      li {
        font-size: 14px;
        padding: 10px;
        color: #00cdff;
      }
    }

    .seamless-warp {
      overflow: hidden;
      .item {
        li {
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          text-align: center;

          span {
            font-size: 14px;
            padding: 5px 10px;
            color: #00cdff;
          }
        }
      }
    }
  }
}
</style>

